module.exports = __webpack_public_path__ + "img/logo.ab11e924.png";